import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { situacionesService } from "../../../../../_services/situaciones.service";
import { calcularMonto, calcularTotal, formatCapital, formatDeudas } from "../../../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { useUser } from "../../../../../hooks/useUser";
import { deudasService } from "../../../../../_services/deudas.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import LoadingModal from "../../../../../components/LoadingModal/LoadingModal";
import { setLoading } from "../../../../../redux/Loading/actions";

const DeudasModal = ({ show, handleClose, imponibles }) => {
  const { loading } = useSelector(e => e.dashboard);
  const dispatch = useDispatch();
  const user = useUser();

  const [data, setData] = useState("");

  const [deudas, setDeudas] = useState();

  const [abogado, setAbogado] = useState();
  const [situaciones, setSituaciones] = useState([]);

  useEffect(() => {
    const getData = async () => {
      dispatch(setLoading(true));

      let response = await situacionesService.getSituaciones();

      if (response?.length) {
        setSituaciones(response.map(e => {
          return {
            ...e,
            value: e.CODIGO,
            label: e.DETALLE_SITUACION
          };
        }));
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      dispatch(setLoading(true));
      try {
        const resDeudas = [];

        // Itera sobre las URLs y realiza las solicitudes secuenciales
        for (const e of imponibles) {
          const resDeuda = await deudasService.getDeuda({
            imponible: e.IMPONIBLE,
            recurso: e.RECURSO
          });

          if (resDeuda?.data?.mensaje) {
            continue;
          }
          else {
            resDeudas.push({ ...resDeuda.data, recurso: e.RECURSO });
            continue;
          }
        }

        setData(resDeudas);
        dispatch(setLoading(false));
      }
      catch (err) {
        setData([]);
        dispatch(setLoading(false));
      }
    };

    getData();

    return () => {
      setData("");
    };
  }, []);

  useEffect(() => {
    if (data?.length) {
      let res = data.map((e) => {
        let deudas = formatDeudas(e.deuda, situaciones);
        let legales = formatDeudas(e.legal, situaciones);
        let planpago = e.planpago;
        let nroPlan = "";
        let deuda = "";
        let legal = "";

        if (e.planpago) {
          let planpago = e.planpago.reduce((prev, current) => {
            if (prev.length) {
              if (prev.some(e => e.NRO_PLAN === current.NRO_PLAN)) {
                return prev;
              }
              else {
                return [...prev, current];
              }
            }
            else {
              return [current];
            }
          }, []);

          nroPlan = planpago;
        }

        if (deudas && deudas["V"]) {
          let a = Object.values(deudas["V"]);
          deuda = a;
        }
        if (legales) {
          let b = [];

          if (legales[1]) {
            const c = Object.values(legales[1]);

            b = c.filter(e => e.legal === user.abogado || user.rol === "admin");
          }
          if (legales["G"]) {
            const d = Object.values(legales["G"]);

            b = [...b, ...d].filter(e => e.legal === user.abogado || user.rol === "admin");
          }

          legal = b;
          // let abogadosList = b.filter(e => e.legal);
          // if (abogadosList?.length) {
          //   const findAbogado = abogados.find((e) => e.codexterno === abogadosList[abogadosList.length - 1].legal);
          //   setAbogado(`${findAbogado.apellido} ${findAbogado.nombre} (${findAbogado.codexterno})`);
          // }
        }
        return {
          ...e,
          deudas,
          legales,
          planpago,
          nroPlan,
          deuda,
          legal
        };
      });

      setDeudas(res);
    }

    return () => {
      setAbogado();
    };
  }, [data]);

  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
        className=""
        centered
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body className="px-5">
          {/* {!loading && !((legal && legal.length) || (deuda && deuda.length) || (nroPlan && nroPlan.length)) ? (
            <>
              <br />
              <br />
              <div className="d-flex justify-content-center" style={{ fontSize: 18 }}>
                No posee deudas
              </div>
            </>
          ) : ""} */}
          {deudas?.length ? (
            deudas.map((e, i) => {
              return (
                <div key={`deuda_${i}`}>
                  <div>
                    <div className="subtable-subtitulo">{e.imponible} - {e.recurso}</div>
                  </div>
                  {e.legal && e.legal.length ? (
                    <Table className="subtable" striped bordered hover>
                      <tbody>
                        <tr>
                          <td colSpan={4} className="subtable-subtitulo">Períodos {abogado ? abogado : ""} en Gestión Legal</td>
                        </tr>
                        <tr>
                          <td className="subtable-key">Año</td>
                          <td className="subtable-key">Período</td>
                          <td className="subtable-key">Situación</td>
                          <td className="subtable-key">Monto</td>
                        </tr>
                        {e.legal.length && e.legal.map((deuda, i) => {
                          return <Fragment key={"deudas1-" + i}>
                            <tr>
                              <td><span>{deuda.anio}</span></td>
                              <td><span>{deuda.periodos.map((p, i) => (i !== deuda.periodos.length - 1) ? p + ", " : p)}</span></td>
                              <td><span>{deuda.situacion}</span></td>
                              <td><span>$ {formatCapital(calcularMonto(deuda.monto))}</span></td>
                            </tr>
                          </Fragment>;
                        })
                        }
                        <tr>
                          <td colSpan={3} className="subtable-key">Total</td>
                          <td className="subtable-key">
                            $ {formatCapital(calcularTotal(e.legal))}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  ) : null}

                  {e.deuda && e.deuda.length ? (
                    <Table className="subtable" striped bordered hover>
                      <tbody>
                        <tr>
                          <td colSpan={3} className="subtable-subtitulo">Períodos Fuera de Gestión Legal</td>
                        </tr>
                        <tr>
                          <td className="subtable-key">Año</td>
                          <td className="subtable-key">Período</td>
                          <td className="subtable-key">Monto</td>
                        </tr>
                        {e.deuda?.length && e.deuda.map((deuda, i) => {
                          return <Fragment key={"deudas2-" + i}>
                            <tr>
                              <td><span>{deuda.anio}</span></td>
                              <td><span>{deuda.periodos.map((p, i) => (i !== deuda.periodos.length - 1) ? p + ", " : p)}</span></td>
                              <td><span>$ {formatCapital(calcularMonto(deuda.monto))}</span></td>
                            </tr>
                          </Fragment>;
                        })
                        }
                        <tr className="">
                          <td className="subtable-key"><span>Total</span></td>
                          <td></td>
                          <td className="subtable-key d-flex">
                            <span style={{ width: "100%" }}>
                              $ {formatCapital(calcularTotal(e.deuda))}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  ) : null}

                  {e.planPago?.length ? (
                    <Table className="subtable" striped bordered hover>
                      <tbody>
                        <tr>
                          <td colSpan={2} className="subtable-subtitulo">
                            PLANES DE PAGO
                          </td>
                        </tr>
                        {
                          e.nroPlan.length ? e.nroPlan.map((e, i) => {
                            return (
                              <tr key={e.NRO_PLAN + e.RECURSO + i}>
                                <td >
                                  NRO {e.NRO_PLAN}
                                </td>
                                <td>
                                  <FontAwesomeIcon
                                    icon={faEye}
                                    size="lg"
                                    className="ml-2"
                                  // onClick={() => handleShow(e)}
                                  />
                                </td>
                              </tr>
                            );
                          })
                            : null
                        }
                      </tbody>
                    </Table>
                  ) : ""}

                  <br />
                </div>
              );
            })
          ) : null}

          {loading ? <LoadingModal show={loading} loading={true} /> : null}
          {/* {showPlan ? <PlanDePagoModal show={showPlan} handleClose={handleClose} data={planDePago} imponible={record.NRO_INMUEBLE} recurso={record.RECURSO} /> : null} */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DeudasModal;
